<script setup lang="ts">
import {ref} from "vue";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import {NotificationTemplate} from "@/notification-template/interfaces";
import TryRcsDialog from "@/rcs/components/try-dialog/TryRcsDialog.vue";
import RcsTagSelect from "@/rcs/components/RcsTagSelect.vue";
import {useRcsSequences} from "@/rcs/composables/useRcsSequences";
import NotificationSequenceSection from "@/rcs/components/tabs/NotificationSequenceSection.vue";

const {tags, selectedTag, sections, initialLoading, selectTag, refreshing} = useRcsSequences();

const template = ref<NotificationTemplate | undefined>();
</script>

<template>
  <BaseFlexSpinner v-if="initialLoading" />
  <div v-else class="flex flex-col gap-12 mt-4">
    <Teleport defer to="#rcs-tag-select">
      <RcsTagSelect
        v-if="tags?.length"
        v-model="selectedTag"
        :tags="tags ?? []"
        @update:model-value="selectTag"
      />
    </Teleport>
    <BaseFlexSpinner v-if="refreshing" />
    <div v-else-if="!sections.length" class="flex flex-col items-center gap-4">
      <p class="text-muted-foreground">
        Aucune séquence de suivi disponible pour le moment.
      </p>
    </div>
    <template v-else>
      <NotificationSequenceSection
        v-for="section in sections"
        :key="section.tag ? `${section.tag.type}-${section.tag.id}` : 'untagged'"
        :tag="section.tag"
        :sequences="section.sequences"
        @template-selected="_template => template = _template"
      />
    </template>

    <TryRcsDialog v-model:model-value="template" />
  </div>
</template>
